module.exports = __webpack_public_path__ + "img/img_phone_device_layered.4dc9b5c3.png";